module.exports = __webpack_public_path__ + "img/empty@2x.b19c9678.png";